import { render } from "./FullPage.vue?vue&type=template&id=498b8dcd"
import script from "./FullPage.vue?vue&type=script&lang=js"
export * from "./FullPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/xianbinlin/workplace/work/projects/notionWeb/app-notion2web/node_modules/vue-loader/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])